module.exports = __webpack_public_path__ + "static/media/step-vector.adf18227.svg";